var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg019AmmhGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2_copy_2",
    "data-name": "Group 2 copy 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #858585;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #424242;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2_copy",
    "data-name": "Polygon 2 copy",
    className: "cls-1",
    d: "M609.259,261.1L942.607,927.79h-666.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    className: "cls-2",
    d: "M609.255,261.1L775.929,594.442H442.581Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    className: "cls-1",
    d: "M1392.6,594.444L1059.25,927.792V261.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_copy",
    "data-name": "Polygon 1 copy",
    className: "cls-1",
    d: "M1392.59,594.444l333.34,333.348V261.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_6",
    "data-name": "Rectangle 1 copy 6",
    className: "cls-1",
    d: "M1059.26,594.444h666.67V927.778H1059.26V594.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_7",
    "data-name": "Rectangle 1 copy 7",
    className: "cls-2",
    d: "M1392.59,594.444h333.34V927.778H1392.59V594.444Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "M_copy",
    "data-name": "M copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_copy_2",
    "data-name": "Polygon 1 copy 2",
    className: "cls-1",
    d: "M609.265,1405.56L275.92,1738.9V1072.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    className: "cls-2",
    d: "M609,1405H276l-0.08-332.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_copy-2",
    "data-name": "Polygon 1 copy",
    className: "cls-1",
    d: "M609.253,1405.56L942.6,1738.9V1072.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_6-2",
    "data-name": "Rectangle 1 copy 6",
    className: "cls-1",
    d: "M275.926,1405.56H942.593v333.33H275.926V1405.56Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_17",
    "data-name": "Rectangle 1 copy 17",
    className: "cls-1",
    d: "M1059,1072h292.99v667.01H1059V1072Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_18",
    "data-name": "Rectangle 1 copy 18",
    className: "cls-1",
    d: "M1437,1072h288.99v667.01H1437V1072Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_9",
    "data-name": "Rectangle 1 copy 9",
    className: "cls-2",
    d: "M1437,1072h288.99v500H1437V1072Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy_10",
    "data-name": "Rectangle 1 copy 10",
    className: "cls-2",
    d: "M1352.01,1573.01h87V1406h-87v167.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg019AmmhGrey);
export default __webpack_public_path__ + "static/media/019_AMMH_Grey.e7e92579ab260ccf263d7075f63b8e30.svg";
export { ForwardRef as ReactComponent };